/* Shop ASB theme JS — minimal, no framework */

// Reveal on scroll
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  els.forEach(el => io.observe(el));
})();

// Mobile nav
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  }
});

// Cart drawer
const drawer = document.querySelector('[data-cart-drawer]');
const overlay = document.querySelector('[data-drawer-overlay]');
function openDrawer() { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; refreshDrawer(); }
function closeDrawer() { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); }
  if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeDrawer(); }
  if (e.target === overlay) closeDrawer();
});

async function refreshDrawer() {
  try {
    const res = await fetch('/?section_id=cart-drawer-contents');
    if (!res.ok) return;
    const html = await res.text();
    const body = drawer?.querySelector('[data-drawer-body]');
    if (body) body.innerHTML = html;
    updateCartCount();
  } catch (err) { console.error(err); }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });
  } catch (err) { console.error(err); }
}
updateCartCount();

// Add to cart (product form)
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-product-form]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('[type="submit"]');
  const label = btn?.textContent;
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
  try {
    const fd = new FormData(form);
    const res = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await res.json();
    openDrawer();
  } catch (err) {
    console.error(err);
    alert('Could not add to cart. Please try again.');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = label; }
  }
});

// Cart line qty change (drawer + cart page)
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-line-change]');
  if (!btn) return;
  e.preventDefault();
  const line = parseInt(btn.dataset.line, 10);
  const delta = parseInt(btn.dataset.lineChange, 10);
  const row = btn.closest('[data-line]');
  const current = parseInt(row?.dataset.quantity || '0', 10);
  const quantity = Math.max(0, current + delta);
  await updateLine(line, quantity);
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-line-remove]');
  if (!btn) return;
  e.preventDefault();
  await updateLine(parseInt(btn.dataset.line, 10), 0);
});

async function updateLine(line, quantity) {
  try {
    const res = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) throw new Error('Cart update failed');
    if (document.body.classList.contains('template-cart')) location.reload();
    else refreshDrawer();
  } catch (err) { console.error(err); }
}

// PDP: variant picker
(function () {
  const forms = document.querySelectorAll('[data-product-form]');
  forms.forEach(form => {
    const dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (_) { return; }

    const priceEl = document.querySelector('[data-pdp-price]');
    const submit = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');

    function currentOptions() {
      const opts = [];
      form.querySelectorAll('input[data-option-index]:checked, select[data-option-index]').forEach(el => {
        opts[parseInt(el.dataset.optionIndex, 10)] = el.value;
      });
      return opts;
    }
    function findVariant() {
      if (product.variants.length === 1) return product.variants[0];
      const opts = currentOptions();
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    function money(cents, code) {
      const n = cents / 100;
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code || 'USD' }).format(n); }
      catch { return `$${n.toFixed(2)}`; }
    }
    function update() {
      const v = findVariant();
      if (!v) { if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; } return; }
      variantInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, product.currency);
      if (submit) {
        if (v.available) { submit.disabled = false; submit.textContent = submit.dataset.labelAdd || 'Add to cart'; }
        else { submit.disabled = true; submit.textContent = submit.dataset.labelSoldOut || 'Sold out'; }
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    form.addEventListener('change', update);
    update();
  });
})();

// PDP: gallery thumbs
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-gallery-thumb]');
  if (!t) return;
  const main = document.querySelector('[data-gallery-main]');
  if (main) { main.querySelector('img').src = t.dataset.src; }
  document.querySelectorAll('[data-gallery-thumb]').forEach(el => el.classList.remove('is-active'));
  t.classList.add('is-active');
});

// PDP qty stepper
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-qty-step]');
  if (!b) return;
  const input = b.parentElement.querySelector('input[name="quantity"]');
  const delta = parseInt(b.dataset.qtyStep, 10);
  input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
});
